module.exports = __webpack_public_path__ + "static/media/logo-dark.68f51c3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-dark.svg
// module id = 1226
// module chunks = 27